<template>
  <div>
    <div
      v-for="(data, dataIndex) in listData"
      :key="dataIndex"
    >
      <LvText h3 lightGray bold class="mb-20" >{{data.title}}</LvText>
      <LvText h5 class="mb-20" >{{data.subTitle}}</LvText>
      <div
        v-for="(item, itemIndex) in data.items"
        :key="itemIndex"
      >
        <LvChecklistCollapse
          :item="item"
          class="mb-20"
          @click-btn="$emit('click-btn', $event)"
          @click-item="$emit('click-item', $event)"
          @click-download="$emit('click-download', $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listData: {
      type: Array,
    },
  },
};
</script>